import gql from "graphql-tag";

export const CREATE_INSURANCE = gql`
  mutation($input: InsuranceCreateInput!) {
    createInsurancePolicy(input: $input) {
      id
      startDate
      expirationDate
      pickedSports {
        id
        title
        synonyms
        key
        insuranceSumLimit
        variants {
          id
          title
          synonyms
          key
          insuranceSumLimit
          insuranceAvgSum
          insuranceMinSumLimit
        }
      }
      maxInsuranceCoverage
      minInsuranceCoverage
      partnerKey
      sports {
        id
        title
        synonyms
        key
        insuranceSumLimit
        insuranceAvgSum
        insuranceMinSumLimit
        variants {
          id
          title
          synonyms
          key
          insuranceSumLimit
          insuranceAvgSum
          insuranceMinSumLimit
        }
      }
      location {
        id
        coefficient
        alpha2
        alpha3
        code
      }
      coverage
      creator {
        id
        role
        phone
        email
        firstName
        lastName
        middleName
        passportID
        passportSeries
      }
      insurers {
        id
        birthday
        role
        email
        firstName
        lastName
        middleName
        passportID
        passportSeries
      }
      packet {
        id
        includeList
        title
        key
        imageURL
      }
      totalPrice
      isCompetition
    }
  }
`;

export const UPDATE_INSURANCE = gql`
  mutation($input: InsuranceUpdateInput!) {
    updateInsurancePolicy(input: $input) {
      id
      startDate
      expirationDate
      telemedicine
      pickedSports {
        id
        title
        synonyms
        key
        insuranceSumLimit
        variants {
          id
          title
          synonyms
          key
          insuranceSumLimit
          insuranceAvgSum
          insuranceMinSumLimit
        }
      }
      maxInsuranceCoverage
      promoCode
      minInsuranceCoverage
      sports {
        id
        title
        synonyms
        key
        insuranceSumLimit
        insuranceAvgSum
        insuranceMinSumLimit
        variants {
          id
          title
          synonyms
          key
          insuranceSumLimit
          insuranceAvgSum
          insuranceMinSumLimit
        }
      }
      location {
        id
        coefficient
        alpha2
        alpha3
        code
      }
      coverage
      creator {
        id
        role
        email
        firstName
        phone
        lastName
        middleName
        passportID
        passportSeries
      }
      insurers {
        id
        birthday
        role
        email
        firstName
        lastName
        middleName
        passportID
        passportSeries
      }
      packet {
        id
        includeList
        title
        key
        imageURL
      }
      totalPrice
      isCompetition
    }
  }
`;

export const SIGNUP = gql`
  mutation($data: UserSignUpInput!) {
    signup(data: $data) {
      token
      user {
        id
        role
        email
        firstName
        lastName
        middleName
        birthday
        passportID
        passportSeries
        createdAt
        updatedAt
      }
    }
  }
`;

export const SIGNIN = gql`
  mutation($data: UserLoginInput!) {
    signin(data: $data) {
      token
      user {
        id
        role
        email
        firstName
        lastName
        middleName
        birthday
        passportID
        passportSeries
        createdAt
        updatedAt
      }
    }
  }
`;

export const PAY_INSURANCE = gql`
  mutation($input: InsurancePayInput!) {
    payInsurance(input: $input) {
      formUrl
      paymentProvider
      status
    }
  }
`;

export const GET_SPORTS = gql`
  query {
    sports {
      id
      title
      synonyms
      key
      insuranceSumLimit
      insuranceAvgSum
      insuranceMinSumLimit
      variants {
        id
        title
        synonyms
        key
        insuranceSumLimit
        insuranceAvgSum
        insuranceMinSumLimit
      }
    }
  }
`;

export const GET_INSURANCE = gql`
  query($id: Int) {
    insurance(id: $id) {
      id
      startDate
      expirationDate
      pickedSports {
        id
        title
        key
      }
      sports {
        id
        title
        key
      }
      location {
        id
        alpha3
        code
      }
      coverage
      creator {
        id
        email
        firstName
        phone
        lastName
        middleName
        birthday
      }
      insurers {
        id
        email
        firstName
        lastName
        middleName
        birthday
      }
      packet {
        id
        title
        key
      }
      totalPrice
      isCompetition
      isPaid
      telemedicine
      createdAt
      updatedAt
      documents {
        name
        link
      }
    }
  }
`;

export const GET_ORDER_INFO = gql`
  mutation($input: UpdateOrderInfoInput) {
    updateOrderInfo(input: $input) {
      insurance {
        id
        startDate
        expirationDate
        pickedSports {
          id
          title
          key
          riskType
        }
        sports {
          id
          title
          key
        }
        location {
          id
          alpha3
          code
        }
        coverage
        creator {
          id
          email
          firstName
          phone
          lastName
          middleName
          birthday
        }
        insurers {
          id
          email
          firstName
          lastName
          middleName
          birthday
        }
        packet {
          id
          title
          key
        }
        totalPrice
        isCompetition
      }
      status
    }
  }
`;

export const LOCATIONS = gql`
  query {
    locations {
      id
      alpha2
    }
  }
`;

export const GET_PDF_INSURANCE = gql`
  query($input: GetInsurancePolicyPDFLinkInput) {
    getInsurancePolicyPDFLink(input: $input)
  }
`;

export const GET_INSURANCES = gql`
  query {
    insurances {
      id
      startDate
      expirationDate
      location {
        coefficient
        alpha2
        alpha3
        code
      }
      totalPrice
      maxInsuranceCoverage
      minInsuranceCoverage
      coverage
      creator {
        id
        role
        email
        phone
        firstName
        lastName
        middleName
        birthday
        passportID
        passportSeries
        createdAt
        updatedAt
      }
      insurers {
        id
        role
        email
        firstName
        lastName
        middleName
        birthday
        passportID
        passportSeries
        createdAt
        updatedAt
      }
      isCompetition
      packet {
        id
        title
        includeList
        key
      }
      sports {
        id
        key
        title
        synonyms
        insuranceSumLimit
        insuranceAvgSum
        insuranceMinSumLimit
        riskType
        riskTypeId
      }
      pickedSports {
        id
        title
        synonyms
        key
        insuranceSumLimit
        insuranceAvgSum
        insuranceMinSumLimit
        riskType
        riskTypeId
      }
      isPaid
      updatedAt
      documents {
        link
        name
      }
    }
  }
`;
export const RESET_PASSWORD = gql`
  mutation($data: ResetPasswordInput!) {
    resetPassword(data: $data) {
      status
    }
  }
`;
